import { Fieldset, Radio, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { ContactImageField } from 'src/Components/Forms/Contact/PhysicalContactForm/ContactImageField';
import { CreateContactDtoTitleEnum } from 'src/Services/API/generated';

import styles from './IdentitySectionForm.module.scss';
import { Props } from './IdentitySectionForm.types';

const IdentitySectionForm = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <Fieldset legend={t('contacts.identity', 'Identité')}>
      <div className={styles.content}>
        <p className={styles.contactTitle}>
          {t('contacts.civilityTitle', 'Civilité')}
          <span className={styles.required}>*</span>
        </p>
        <Radio.Group value={form.getInputProps('title')} {...form.getInputProps('title')}>
          <div className={styles.flexRow}>
            <Radio value={CreateContactDtoTitleEnum.Mr} label={t('contacts.mr', 'M')} />
            <Radio value={CreateContactDtoTitleEnum.Ms} label={t('contacts.ms', 'Mme')} />
          </div>
        </Radio.Group>

        <div className={styles.flexRow}>
          <TextInput
            placeholder={t('contacts.firstName', 'Prénom')}
            required
            {...form.getInputProps('firstName')}
          />
          <TextInput
            placeholder={t('contacts.lastName', 'Nom')}
            required
            {...form.getInputProps('lastName')}
          />
        </div>

        <ContactImageField form={form} label={t('contacts.profileImage', 'Photo de profil')} />
      </div>
    </Fieldset>
  );
};

export default IdentitySectionForm;
